import { Component, Input, OnInit } from '@angular/core';
import {
  EMenuButtonItemType,
  EMenuItemPosition,
  IMenuButtonProperties,
} from '../../../store/models/menu-button.model';

@Component({
  selector: 'app-menu-button',
  templateUrl: './menu-button.component.html',
  styleUrls: ['./menu-button.component.scss'],
})
export class MenuButtonComponent implements OnInit {

  @Input() properties: IMenuButtonProperties;

  @Input() target: any;

  buttonTypes = EMenuButtonItemType;

  componentReady: boolean;

  constructor() {
  }

  ngOnInit(): void {
    if (!this.properties) {
      this.properties = {
        items: [],
      };
    }

    this.properties.items.forEach(item => {
      if (item.getLabel && this.target) {
        setTimeout(() => item.label = item.getLabel(this.target));
      }

      if (item.getRoute && this.target && !item.route) {
        item.route = item.getRoute(this.target);
      }
    });

    this.properties.items = this.properties.items.filter(item => {
      if (!item.isShown || !this.target) {
        return true;
      }

      return item.isShown(this.target);
    });
    if (!this.properties.position) {
      this.properties.position = EMenuItemPosition.BELOW;
    }

    this.componentReady = true;
  }
}
